let userLang = null;

try{
    userLang = localStorage.getItem('language.selected');
}catch(e){}

if(userLang === null || userLang === undefined){
    userLang = navigator.language.substr(0,2);
}

let availableLanguages = [
    {
        id: 3,
        code: "en",
        name: 'English',
        flag_img_path: '/img/flags/en.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
    {
        id: 1,
        name: 'Español',
        code: "es",
        flag_img_path: '/img/flags/es.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
    {
        id: 2,
        name: 'Português',
        code: "pt",
        flag_img_path: '/img/flags/br.png',
        dateTimeFormat: {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric'
            },
        },
        numberFormat: {
            currency: {
                style: 'currency'
            }
        }
    },
];

let index = availableLanguages.findIndex((element) => element.code === userLang);

let temp = availableLanguages[0];
availableLanguages[0] = availableLanguages[index];
availableLanguages[index] = temp;

export default availableLanguages;